import React, { useMemo, useState } from "react";
import Stack from "@mui/material/Stack";
import Badge from "@mui/material/Badge";
import {
  AlertComponent,
  SearchInputComponent,
  SelectInputComponent,
} from "../../../common/components";
import FilterIcon from "../../../assets/icons/filter-icon.svg";
import { LeadFilterProps } from "./lead-filter.props";
import {
  allLeadsOptions,
  createLeadsOptions,
  actionsOptions,
  createLeadsButtonOptions,
} from "./lead-filter.constant";
import "./lead-filter.scss";
import { useNavigate } from "react-router-dom";
import { routes } from "../../../constants/routes";
import SplitButtonComponent from "../../../common/components/split-button-component/split-button";
import { useResourcePermissions } from "../../../common/hooks/resource-permissions";
import MODULES from "../../../constants/modules";
import ImportModal from "../../../common/components/import-modal/import-modal";
import { uploadFile } from "../../../api/lead";
import { useSetLoading } from "../../../common/hooks/appearance";
import { useLogin } from "../../../common/hooks/useUser";
import useMediaQuery from '@mui/material/useMediaQuery';

const LeadFilter: React.FC<LeadFilterProps> = (props: any) => {
  const {
    isOpenFilter,
    setIsOpenFilter,
    selectedLeadsFilter,
    selectedAllLeads,
    setSelectedAllLeads,
    selectedCreateLeads,
    setSelectedCreateLeads,
    selectedActions,
    setSelectedActions,
    onSearch,
    searchRef,
    resetSearch,
    isResetSearch,
    disabled,
    handleActionTrigger,
    disableSelectedLeads,
    setIsShowCreateLead,
    isShowCreateLead,
    selectOpen,
    setSelectOpen,
    totalLeads,
    showImportModal,
    setShowImportModal,
    isShowCreateLeadSection,
    setIsShowCreateLeadSection,
    fetchLeads,
  } = props;
  const navigate = useNavigate();
  const { canWrite, canDelete } = useResourcePermissions(MODULES.LEAD_DETAILS);
  const [alertMessage, setAlertMessage] = useState<string | null>(null);
  const [alertType, setAlertType] = useState<
    "error" | "success" | "info" | "warning"
  >("info");
  const [alertOpen, setAlertOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const userDetails = useLogin();
  const userRole = userDetails.userDetails.roles.role;
  const isMobile = useMediaQuery('(max-width:768px)');
  const { canExport } = useResourcePermissions(MODULES.EXPORT);
  const filteredActionsOptions = actionsOptions.filter((option) => {

    if (!canExport && option.value === "Export Leads") {
      return false;
    }

    if ((option.value === "Archive" && !canDelete)) {
      return false;
    }
    if(option.value !== "Archive" && !canWrite) return false
    return true;
  });

  const handleAlertClose = () => {
    setAlertOpen(false);
  };
  const showLoading = useMemo(() => loading, [loading]);
  useSetLoading(showLoading);
  const handleOpen = () => {
    if (setSelectOpen) setSelectOpen(true);
  };
  const handleBlur = () => {
    if (setSelectOpen) setSelectOpen(false);
  };
  const handleCreateLeadAction = (option: { value: string; id: number }) => {
    setSelectedCreateLeads(option.value);
    if (option.value === "Import Leads") {
      setShowImportModal(true);
    } else if (option.value === "Social Media Import") {
      navigate(routes.SOCIALIMPORTLEAD);
    }
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      handleUpload(event.target.files[0]);
    }
  };
  const handleUpload = async (file: File) => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("file", file);
      await uploadFile(formData);
      setLoading(false);
      setAlertMessage("Uploaded successfully");
      setAlertType("success");
      setAlertOpen(true);
      setShowImportModal(false);
      fetchLeads();
      setTimeout(() => {
        fetchLeads();
      }, 5000);
      setSelectedCreateLeads("Create Leads");
    } catch (error: any) {
      setLoading(false);
      setAlertMessage(error?.response?.data?.message || "Upload failed");
      setAlertType("error");
      setAlertOpen(true);
      setShowImportModal(false);
      setSelectedCreateLeads("Create Leads");
      console.error(error);
    }
  };

  return (
    <div className="lead-list-search-filter-wrapper">
       {isMobile ? (
       <div className="search-filter-group">
        <div className="lead-list-search-wrapper">
    <SearchInputComponent
      placeholder="Search by Lead name, Email, Lead owner etc."
      onSearch={onSearch}
      isReset={isResetSearch}
      ref={searchRef}
    />
    </div>
   
    <div
          className="lead-list-icon-filter"
          onClick={() => setIsOpenFilter(!isOpenFilter)}
          tabIndex={0}
        >
          <Stack spacing={4} direction="row" sx={{ color: "action.active" }}>
            <Badge
              color="secondary"
              sx={{
                "& .MuiBadge-badge": {
                  backgroundColor: "#887952",
                },
              }}
              badgeContent={selectedLeadsFilter}
            >
              <img src={FilterIcon} alt="Filter Icon" />
            </Badge>
          </Stack>
        </div>
   
    </div>
     ):(
      <div className="lead-list-search-wrapper">
    <SearchInputComponent
      placeholder="Search by Lead name, Email, Lead owner etc."
      onSearch={onSearch}
      isReset={isResetSearch}
      ref={searchRef}
    />
    </div>
     )}
      <div className="lead-list-filter-wrapper">
        {/* <div className="lead-list-lead-filter">
          <SelectInputComponent
            fieldName={"allLeads"}
            value={[selectedAllLeads || "All Leads"]}
            onChange={(e: any) => setSelectedAllLeads(e)}
            multiple={false}
            options={allLeadsOptions}
          />
        </div> */}
         {!isMobile && (
        <div
          className="lead-list-icon-filter"
          onClick={() => setIsOpenFilter(!isOpenFilter)}
          tabIndex={0}
        >
          <Stack spacing={4} direction="row" sx={{ color: "action.active" }}>
            <Badge
              color="secondary"
              sx={{
                "& .MuiBadge-badge": {
                  backgroundColor: "#887952",
                },
              }}
              badgeContent={selectedLeadsFilter}
            >
              <img src={FilterIcon} alt="Filter Icon" />
            </Badge>
          </Stack>
        </div>
         )}

        <div className="lead-list-create-filter">
          <SplitButtonComponent
            fieldName="createleads"
            createFieldName="createLeads"
            value={selectedCreateLeads || "Create Leads"}
            options={createLeadsOptions}
            optionsCreate={createLeadsButtonOptions(
              setIsShowCreateLead,
              isShowCreateLead,
              isShowCreateLeadSection,
              setIsShowCreateLeadSection
            )}
            onSelect={handleCreateLeadAction}
            navigateTo={routes.CREATELEAD}
            resourceName={MODULES.LEAD_DETAILS}
          />
          <ImportModal
            openModal={showImportModal}
            toggleModal={() => {
              setShowImportModal(false);
              setSelectedCreateLeads("Create Leads");
            }}
            handleFileChange={handleFileChange}
            module="Leads"
          />
        </div>

        {(canDelete || canWrite || userRole === "Super Admin") &&<div className="lead-list-action-filter">
          <SelectInputComponent
            fieldName={"actions"}
            value={[selectedActions || "Actions"]}
            multiple={false}
            options={filteredActionsOptions}
            setSelectedActions={setSelectedActions}
            handleActionTrigger={handleActionTrigger}
            disableSelectedLeads={disableSelectedLeads}
            selectOpen={selectOpen}
            handleOpen={handleOpen}
            handleBlur={handleBlur}
            disabled={disabled}
            totalLeads={totalLeads}
            isEmailConfigured={userDetails?.isEmailConfigured}
          />
        </div>}
      </div>
      <AlertComponent
        message={alertMessage}
        type={alertType}
        open={alertOpen}
        onClose={handleAlertClose}
      />
    </div>
  );
};

export default LeadFilter;
